import { Pagination } from 'antd';
import React from 'react';
import ExportList from './export-list';
import {axios_} from '../../../tools/axios_';
import {connect} from 'react-redux';
import {Utils} from "../../../tools/utils";

let timer = '';
class Index extends React.Component {
    constructor( props) {
        super( props );
        this.state = {
            loading:false,
            total:0,
            pageSize:'10',
            pageNum:'1',
        };
    }
    componentDidMount() {
        this.getData();
    }
    componentWillUnmount() {
        if(timer) {
            clearTimeout(timer);
        }
    }

    ExportListRef = React.createRef()

    getData = () => {
        if(timer) {
            clearTimeout(timer);
        }
        this.setState({loading: true},()=>{
            const {pageNum, pageSize} = this.state;
            axios_({
                url: '/api/insurepolicy/merchant/export/list',
                method: 'post',
                headers: {
                    'access-token':this.props.token
                },
                data:{ pageNum: pageNum +'', pageSize: pageSize + '',   creator: Utils.getUserId() }
            }).then(res=>{
                const { dataInfo, pageInfo } = res.data.data;
                this.setState({total: pageInfo.total});
                dataInfo.forEach((val)=>{
                    if(val.queryString){
                        val.detail = JSON.parse(val.queryString);
                    }else if(val.requestBody){
                        val.detail = JSON.parse(val.requestBody);
                    }
                });
                if (this.ExportListRef && this.ExportListRef.current && this.ExportListRef.current.setState){// 列表加载中，返回上一页面，current 被销毁
                    this.ExportListRef.current.setState({list:dataInfo},()=>{
                        timer = setTimeout(()=>{
                            this.getData();
                        },3000);
                    });
                }
            }).finally(()=> this.setState({loading: false}));
        });

    }

    render() {
        return <div className='list' style={{marginTop: '10px'}} >
            <h2>已生成报表</h2>
            <ExportList ref={this.ExportListRef} loading={this.state.loading}/>
            <Pagination
                pageSize={Number(this.state.pageSize)}
                defaultCurrent={1}
                showSizeChanger
                showTotal={(total, range) => `共${total} 条`}
                showQuickJumper={true}
                current={Number(this.state.pageNum)}
                total={this.state.total}
                onChange={(page, pageSize)=>{
                    this.setState({pageNum:page, pageSize},()=>{
                        this.getData();
                    })
                }}
                onShowSizeChange={(current,size)=>{
                    this.setState({pageNum:current, pageSize:size},()=>{
                        this.getData();
                    })
                }}
                className='pagination'/>
        </div>;
    }
}
function mapState (state) {
    return {token: state.token}
}


export default connect(mapState)(Index);
